// extracted by css-extract-rspack-plugin
export default {"srOnly":"input-module__srOnly___sG30B common-module__screenReaderOnly___r5DtB"};